"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
var react_1 = __importDefault(require("react"));
var styles_1 = require("@mui/styles");
var material_1 = require("@mui/material");
var fb_badge_png_1 = __importDefault(require("../../../../../images/socialMedia/fb_badge.png"));
var ig_badge_png_1 = __importDefault(require("../../../../../images/socialMedia/ig_badge.png"));
var useStyles = (0, styles_1.makeStyles)({
    header: {
        height: '100px',
        width: '100%',
        backgroundImage: "linear-gradient(rgba(0,0,0,0.8), rgba(0,0,0,0.05))",
        display: 'flex',
        alignItems: 'center',
        color: 'white',
        position: 'absolute',
        top: '0px',
        left: '0px',
        zIndex: 5
    },
    logoSpace: {
        width: '100px'
    },
    logo: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        zIndex: 10,
        height: '100px',
        width: '100px'
    }
});
var Logo = function (_a) {
    var classes = _a.classes, imageSrc = _a.imageSrc;
    return (react_1.default.createElement("img", { className: classes, src: imageSrc, alt: 'instagram/facebook logo' }));
};
var SocialMediaHeader = function (_a) {
    var _b = _a.mediaProfile, platform = _b.platform, socialMedia = _b.socialMedia;
    var classes = useStyles();
    var accountName = platform === seesignage_utils_1.SocialMediaPlatform.facebook
        ? socialMedia === null || socialMedia === void 0 ? void 0 : socialMedia.name
        : "@".concat(socialMedia === null || socialMedia === void 0 ? void 0 : socialMedia.username);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Logo, { classes: classes.logo, imageSrc: platform === seesignage_utils_1.SocialMediaPlatform.facebook ? fb_badge_png_1.default : ig_badge_png_1.default }),
        react_1.default.createElement("div", { className: classes.header },
            react_1.default.createElement("div", { className: classes.logoSpace }),
            react_1.default.createElement(material_1.Typography, { variant: 'h4', fontSize: '40px' }, accountName))));
};
exports.default = SocialMediaHeader;
//# sourceMappingURL=SocialMediaHeader.js.map